import { makeStyles } from '@mui/styles'

const baseText = {
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 auto',
} as const;

export default makeStyles((theme) => ({
    PlannedExpertiseCardList: {
        position: 'relative',
    },
    PlannedExpertiseCardListCount: {
        position: 'absolute',
        top: '-2.7rem',
        left: 0,
    },
    PlannedExpertiseCardListCountText: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.main,
    },
    PlannedExpertiseCardListContent: {
      marginBottom: '5rem',
    },
    PlannedExpertiseCardListMainContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1rem',
        maxWidth: '1616px',
        width: '100%',
        margin: '0 auto',
    },
    PlannedExpertiseDisabledText: {
        ...baseText,
        maxWidth: '900px',
    },
    PlannedExpertiseEmptyText: {
        ...baseText,
        maxWidth: '600px',
    },
    PlannedExpertiseCards: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '2.5rem',
    },
    PlannedExpertiseCardsInner: {
        width: '100%',
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        flexWrap: 'wrap',
        gap: '.9rem',
    },
    PlannedExpertiseCardsButonContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    PlannedExpertiseCardsButonContainerMore: {
        marginTop: '2.5rem',
    },
    PlannedExpertiseCardWrapper: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'stretch',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(820)]: {
            width: 'calc(50% - .9rem)',
        },
        '@media (min-width: 1300px) and (max-width: 1500px)': {
            width: 'calc(33.333% - .9rem) !important',
        },
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(1600)]: {
            width: 'calc(25% - .9rem)',
        },
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(2000)]: {
            width: 'calc(20% - .9rem)',
        },
    },
    PlannedExpertiseCardWrapperPreview: {
      // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
      [theme.breakpoints.up(1300)]: {
        width: 'calc(25% - .9rem)',
      },
      // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
      [theme.breakpoints.up(1600)]: {
        width: 'calc(25% - .9rem)',
      },
      // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
      [theme.breakpoints.up(2000)]: {
        width: 'calc(25% - .9rem)',
      },
    },
    PlannedExpertiseCard: {
        width: '100%',
        padding: '2rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        border: `1px solid ${theme.palette.lightGrey.half}`,
        boxShadow: '0px 6px 18px rgba(7,164,165,0.11)',
        borderRadius: '12px',
        background: '#ffffff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column',
    },
    PlannedExpertiseCardHeader: {
        width: '100%',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        border: `2px solid ${theme.palette.lightGrey.harder}`,
        borderRadius: '9px',
        padding: '.7rem 1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1rem',
        gap: '1rem',
        [theme.breakpoints.between(1400, 1450)]: {
            gap: '0.5rem',
        },
    },
    PlannedExpertiseCardHeaderItem: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '.5rem',
    },
    PlannedExpertiseCardHeaderDelete: {
        padding: '0',
        border: `1.5px solid #FB355D`,
        borderRadius: '10px',
        width: '34px',
        minWidth: '34px',
        height: '34px',
        margin: '-6px 0',
        '& svg': {
          width: '18px',
          height: '18px',
        },
    },
    PlannedExpertiseCardContent: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '1rem',
        flex: 1,
    },
    PlannedExpertiseCardContentItem: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '.2rem',
    },
    PlannedExpertiseCardContentItemLabel: {
        fontSize: '.85rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.medium,
    },
    PlannedExpertiseCardContentItemSpeciality: {
      fontFamily: 'AvertaPE-Regular',
      fontSize: '14px',
      fontWeight: '400',
      color: '#4E5054',
    },
    PlannedExpertiseCardContentItemValue: {
        fontSize: '1.15rem',
        wordBreak: 'break-word',
    },
    PlannedExpertiseCardContentItemInfo: {
        fontWeight: 400,
        fontSize: '.9rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.half,
    },
    PlannedExpertiseAvis: {
      display: 'flex',
      padding: '8px 16px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      borderRadius: '24px',
      background: '#E7E8FF',
    },
    PlannedExpertiseAvisText: {
      fontFamily: 'AvertaPE-Semibold',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: '400px',
      lineHeight: '24px',
      letterSpacing: '0.15px',
      // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
      color: theme.palette.expertise.main,
    },
    PlannedExpertiseCardBottom: {
        width: '100%',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        borderTop: `1px solid ${theme.palette.lightGrey.dark}`,
        marginTop: '1rem',
        paddingTop: '1rem',
    },
    PlannedExpertiseCardBottomInfo: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '1rem',
    },
    PlannedExpertiseCardBottomInfoIcon: {
        width: '2rem',
        height: '2rem',
    },
    PlannedExpertiseCardBottomInfoLabel: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.mediumDark,
    },
    PlannedExpertiseCardBottomButtonContainer: {
        width: '100%',
    },
    PlannedExpertiseCardBottomButton: {
        width: '100%',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        background: theme.palette.expertise.main,
        marginTop: '1rem',
        gap: '.5rem',
        '&:hover': {
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            background: theme.palette.expertise.hover,
        },
    },
    PlannedExpertiseCardBottomButtonIcon: {
        width: '1rem',
        height: '1rem',
    },
    PlannedExpertiseCardBottomButtonLabel: {
        color: '#ffffff',
    },
    PlannedExpertiseCardOverdue: {
        // boxShadow: `0px 6px 18px ${theme.palette.red.shadow}`,
    },
    PlannedExpertiseCardHeaderOverdue: {
        '& *': {
            // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
            color: theme.palette.red.main,
        },
    },
    PlannedExpertiseCardOverdueText: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.red.main,
        fontSize: '.8rem',
        maxWidth: '20rem',
        marginTop: '1rem',
        marginBottom: '1rem',
    },
    PlannedExpertiseHeader: {
        maxWidth: '1616px',
        width: '100%',
        margin: '0 auto',
        marginTop: '2rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        borderBottom: `1px solid ${theme.palette.lightGrey.dark}`,
    },
    PlannedExpertiseHeaderWrapper: {
        width: '100%',
        borderBottom: `1px solid ${theme.palette.lightGrey.dark}`,
    },
    PlannedExpertiseHeaderButtonsContainer: {
        marginBottom: '0.5rem',
    },
    PlannedExpertiseHeaderContent: {
      marginBottom: '0.5rem',
    },
    PlannedExpertiseHeaderLeft: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '1rem',
    },
    PlannedExpertiseHeaderTitleContainer: {},
    PlannedExpertiseHeaderTitle: {
        fontSize: '1.6rem',
        fontWeight: '800',
    },
    PlannedExpertiseHeaderTitleContainerCount: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '.5rem',
    },
    PlannedExpertiseHeaderTitleContainerCountButton: {
        padding: '.3rem',
        textDecoration: 'underline',
    },
    PlannedExpertiseHeaderRight: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '1rem',
    },
    PlannedExpertiseHeaderSearch: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        border: `2px solid ${theme.palette.lightGrey.dark}`,
        borderRadius: '9px',
        background: '#ffffff',
        minWidth: '0',
        '& fieldset': {
            border: 'none',
        },
        '& .MuiInputBase-input': {
            height: '1.75rem',
            padding: '.75rem',
        },
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(820)]: {
            minWidth: '22rem',
        },
    },
    PlannedExpertiseHeaderSearchLabel: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '.5rem',
        top: '-2rem',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.mediumDark,
    },
    PlannedExpertiseHeaderSearchDialogPaper: {
        width: '90%',
        // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
        [theme.breakpoints.up(820)]: {
            width: 'auto',
        },
    },
    PlannedExpertiseCardsNoPreviewBottom: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '.7rem',
    },
    PlannedExpertiseCardsEndOfList: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.light,
    },
    PlannedExpertiseCardsCountContainer: {
        marginBottom: '1rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '.7rem',
    },
    PlannedExpertiseCardsCount: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        color: theme.palette.typography.light,
    },
    PlannedExpertiseCardsCountContainerLoadbar: {
        width: '80%',
        height: '4px',
        borderRadius: '100px',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        background: theme.palette.lightGrey.medium,
    },
    PlannedExpertiseCardsCountContainerLoadbarProgress: {
        height: '100%',
        borderRadius: '100px',
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        background: theme.palette.primary.main,
    },
    PlannedExpertiseCardListLoading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '4rem 0',
    },
    PlannedExpertiseCardListLoadingLoader: {
        '&::before': {
            borderWidth: '6px',
        },
    },
    PlannedExpertiseCardListLoadingMessage: {
        marginTop: '1rem',
        fontSize: '1.4rem',
    },
    PlannedExpertisePopUpDelete: {
        marginTop: '-1.2rem',
        marginBottom: '1.2rem',
        textAlign: 'left',
        alignSelf: 'flex-start',
    },
    PlannedExpertisePopUpDeleteBackdrop: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        backgroundColor: theme.palette.expertise.black + '!important',
    },
    PlannedExpertiseFillAddressDialogBackdrop: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        backgroundColor: theme.palette.expertise.black + '!important',
    },
    dialogPaperNoScroll: {
        overflow: 'hidden',
        '& .MuiDialogContent-root': {
            overflow: 'hidden',
        },
    },
}))
